import { render } from "./EventsList.vue?vue&type=template&id=50d852d4"
import script from "./EventsList.vue?vue&type=script&lang=jsx"
export * from "./EventsList.vue?vue&type=script&lang=jsx"

import "./EventsList.vue?vue&type=style&index=0&id=50d852d4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__